export default __webpack_public_path__ + "static/media/Activity.2da91a2e.jpeg";